var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 9C12.4219 9 14.3281 10.9062 14.3281 13.2188V14.5C14.3281 15.3438 13.6406 16 12.8281 16H1.82812C0.984375 16 0.328125 15.3438 0.328125 14.5V13.2188C0.328125 10.9062 2.20312 9 4.51562 9C5.42188 9 5.82812 9.5 7.32812 9.5C8.79688 9.5 9.20312 9 10.1094 9ZM13.3281 14.5V13.2188C13.3281 11.4375 11.8906 10 10.1094 10C9.51562 10 8.89062 10.5 7.32812 10.5C5.73438 10.5 5.14062 10 4.51562 10C2.73438 10 1.32812 11.4375 1.32812 13.2188V14.5C1.32812 14.7812 1.54688 15 1.82812 15H12.8281C13.0781 15 13.3281 14.7812 13.3281 14.5ZM7.32812 8C5.10938 8 3.32812 6.21875 3.32812 4C3.32812 1.8125 5.10938 0 7.32812 0C9.51562 0 11.3281 1.8125 11.3281 4C11.3281 6.21875 9.51562 8 7.32812 8ZM7.32812 1C5.67188 1 4.32812 2.375 4.32812 4C4.32812 5.65625 5.67188 7 7.32812 7C8.95312 7 10.3281 5.65625 10.3281 4C10.3281 2.375 8.95312 1 7.32812 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.116b4288a6bc175b84e7f03d55d02351.svg";
export { ForwardRef as ReactComponent };